import React, { useState } from "react";

import { Typography } from "clearsense-ui/components";

import FilterDropDown from "./FilterDropDown";
import StatItem from "./StatItem";

const ModelStatistics = ({ data }) => {
  const [visibleStats, setVisibleStats] = useState(data);
  const [hiddenStats, setHiddenStats] = useState([]);

  return (
    <>
      <Typography
        style="h3"
        type="semibold"
        className="flex items-center justify-between flex-none px-6 py-4 border-b-2"
      >
        Model Statistics
        {data && (
          <FilterDropDown
            visibleStats={visibleStats}
            setVisibleStats={setVisibleStats}
            hiddenStats={hiddenStats}
            setHiddenStats={setHiddenStats}
          />
        )}
      </Typography>

      {!data ? (
        <div className="min-h-[250px] flex justify-center items-center">
          <Typography>Failed to Load data</Typography>
        </div>
      ) : visibleStats.length ? (
        <div className="grid grid-cols-1 p-6 gap-y-5 gap-x-5 lg:grid-cols-2 2xl:grid-cols-3">
          {visibleStats.map(stat => (
            <StatItem
              key={stat.key}
              name={stat.name}
              value={stat.value}
              isPercent={stat.isPercent}
              setVisibleStats={setVisibleStats}
            />
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center w-full h-56 p-6">
          <Typography className="text-xl text-center text-gray-300">
            No metrics selected
          </Typography>
        </div>
      )}
    </>
  );
};

export default ModelStatistics;
